import { ConsultationMode } from "../types";
import { resolveAppointmentSystemType } from "../../utils/resolveAppointmentSystemType";
import { FOLLOW_UP_RESET } from "./followUpSlice";
export const LOCATION_UNSELECTED = "";
export const createDoctorSelectionSlice = (set, get) => ({
    selectedDoctor: null,
    selectedAddressId: null,
    activeSystemType: "SCHEDULED",
    searchQuery: "",
    specializationFilter: "all",
    locationFilter: LOCATION_UNSELECTED,
    consultationMode: ConsultationMode.OFFLINE,
    selectDoctor: (doctor, addressId) => {
        const { workspace, activeSystemType: prevSystemType, selectedDoctor, selectedAddressId, } = get();
        const newSystemType = resolveAppointmentSystemType(doctor, workspace);
        if (selectedDoctor?.id === doctor.id &&
            selectedAddressId === addressId &&
            newSystemType === prevSystemType) {
            if (selectedDoctor !== doctor)
                set({ selectedDoctor: doctor });
            return;
        }
        set({
            selectedDoctor: doctor,
            selectedAddressId: addressId,
            activeSystemType: newSystemType,
            selectedSlot: null,
            selectedDuration: null,
            selectedPack: null,
            selectedActiveSessionPack: null,
            ...FOLLOW_UP_RESET,
            ...(newSystemType !== prevSystemType
                ? { currentStep: "schedule" }
                : {}),
        });
    },
    clearSelectedDoctor: () => set({
        selectedDoctor: null,
        selectedAddressId: null,
        selectedSlot: null,
        selectedDuration: null,
        ...FOLLOW_UP_RESET,
    }),
    setSearchQuery: (q) => set({ searchQuery: q }),
    setSpecializationFilter: (f) => set({ specializationFilter: f }),
    setLocationFilter: (f) => set({ locationFilter: f }),
    setConsultationMode: (mode) => {
        if (get().consultationMode === mode)
            return;
        set({ consultationMode: mode, selectedDuration: null });
    },
});
